import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MainMenuItemType {
	canRead: boolean;
	canUpdate: boolean;
	totalCount: number;
	newCount: number;
	toActionCount: number;
}

const initialMainMenuItemState: MainMenuItemType = {
	canRead: true,
	canUpdate: true,
	totalCount: 107,
	newCount: 35,
	toActionCount: 50
};

export interface MainMenuType {
	dashboard: MainMenuItemType;
	[key: string]: MainMenuItemType;
}

const initialMainMenuState: MainMenuType = {
	dashboard: { ...initialMainMenuItemState }
};

export const MainMenuSlice = createSlice({
	name: 'mainMenu',
	initialState: initialMainMenuState,
	reducers: {
		update: (state, action: PayloadAction<MainMenuType>) => {
			// -- THIS --
			// state = Object.assign(state, action.payload);
			// -- OR --
			// return { ...state, ...action.payload };
			// Nothing else actually updates the state. Good job plugin.

			state = Object.assign(state, action.payload);
		}
	}
});

export default MainMenuSlice;
